import { ColumnDef } from '@tanstack/react-table'

import { SORT_FILTER_TRAIT_FULLTEXT } from '../../constants'
import {
  SortFilterTraitFilter,
  SortFilterTraitSort,
} from '../../types/sort-filter-trait'
import { FilterDefinitionWithComponent } from '../useDebouncedFilterValue/use-debounced-filter-value'

export const extractValidFilterFields = ({
  registeredFilterComponents,
}: {
  registeredFilterComponents: FilterDefinitionWithComponent[]
}): SortFilterTraitFilter['field'][] => {
  return registeredFilterComponents.map((filter) => {
    return 'name' in filter && typeof filter.name === 'string'
      ? filter.name
      : SORT_FILTER_TRAIT_FULLTEXT
  })
}

export const extractValidSorts = <T>({
  columns,
}: {
  columns: ColumnDef<T, any>[]
}): SortFilterTraitSort['field'][] => {
  const result: SortFilterTraitSort['field'][] = []

  const columnsWithSort = columns.filter((column) => {
    return column.enableSorting !== false
  })

  columnsWithSort.forEach((column) => {
    if (
      column.meta?.alternateSortKey &&
      column.meta?.alternateSortKey.length > 0
    ) {
      result.push([column.meta.alternateSortKey])
    } else if (
      column.id &&
      typeof column.id === 'string' &&
      column.id.length > 0
    ) {
      result.push([column.id])
    }
  })

  return result
}
